import { Action, createReducer, on } from '@ngrx/store';
import {
  toggleHeaderExpand,
  toggleMainMenuExpanded,
} from '../actions/main-menu.actions';

import { MenuItem } from 'src/app/core/models/main-menu.models';
import { loginSuccess } from '../actions/auth.actions';
import { produce } from 'immer';
import { setAppSection } from '../actions/core.actions';

export interface MainMenuState {
  mainMenuExpanded: boolean;
  menuItems: Array<MenuItem>;
  menuItemsSecondary: Array<MenuItem>;
  canToggleMenu: boolean;
  mainMenuLocked: boolean;
}

export const initialState: MainMenuState = {
  mainMenuExpanded: false,
  menuItems: [],
  menuItemsSecondary: [],
  canToggleMenu: true,
  mainMenuLocked: false,
};

const _mainMenuReducer = createReducer(
  initialState,
  on(toggleMainMenuExpanded, (state) => ({
    ...state,
    mainMenuExpanded: !state.mainMenuExpanded,
  })),

  on(loginSuccess, (state, { response }) => ({
    ...state,
    mainMenuExpanded: response.user.menu_state_open,
  })),
  on(setAppSection, (state, { appSection, menuItems }) => ({
    ...state,
    menuItems: !state.mainMenuLocked ? menuItems : state.menuItems || [],
  })),

  on(
    toggleHeaderExpand,
    produce((draft, { menuItem }) => {
      const target = draft.menuItems.find((i) => i.id === menuItem.id);

      if (target) {
        target.expanded = !menuItem.expanded;
      }
    }),
  ),
);

export function mainMenuReducer(
  state: MainMenuState | undefined,
  action: Action,
) {
  return _mainMenuReducer(state, action);
}
